import {
  Paper,
  Show,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography
} from '@sanlam-glacier/app-common/components';
import { MultiViewPaperProps } from './multi-view-paper.type';
import style from './multi-view-paper.module.scss';
import { useState } from 'react';
import { Block, Grid } from '@sanlam-glacier/app-common/modules/grid';
import { Text } from 'components/molecules/text/Text';
import { IconTooltip } from '../icon-tooltip/IconTooltip';
import { EmptyRow } from 'components/atoms/empty-row/EmptyRow';

export const MultiViewPaper = ({ title, tooltipText, views }: MultiViewPaperProps) => {
  const isSingleView = views.length <= 1;
  const [selectedView, setSelectedView] = useState<string>(views.at(0)?.id ?? '');

  const renderCurrentView = () => {
    if (isSingleView) return views.at(0)?.content ?? null;
    const viewToRender = views.find((view) => view.id === selectedView);
    return viewToRender?.content ?? null;
  };

  return (
    <Paper
      elevation
      shadow={Paper.SHADOW.SMALL}
      rounding={Paper.ROUNDING.MEDIUM}
      className={style.paper}
      borderType={Paper.BORDER_TYPE.SOLID}
    >
      <Grid>
        <Grid row className={style.row}>
          <Block lg={8} md={8}>
            <div className={style.tooltipHeader}>
              <Text variant={Typography.VARIANT.H5}>{title}</Text>
              {tooltipText ? (
                <IconTooltip position={Tooltip.POSITION.TOP} className={style.tooltip}>
                  {tooltipText}
                </IconTooltip>
              ) : null}
            </div>
          </Block>
          <Show when={!isSingleView}>
            <Block lg={4} md={4} justify='end'>
              <ToggleButtonGroup
                controlled
                exclusive
                size={ToggleButtonGroup.SIZE.SMALL}
                selected={[selectedView.toString()]}
                onChange={(value) => {
                  if (value) setSelectedView(value.toString());
                }}
              >
                {views.map((view) => (
                  <ToggleButton
                    key={view.id}
                    aria-label={view.id}
                    value={view.id}
                    icon={view.icon}
                  />
                ))}
              </ToggleButtonGroup>
            </Block>
          </Show>
        </Grid>
        <EmptyRow />
      </Grid>
      {renderCurrentView()}
    </Paper>
  );
};
